import { render } from "./FormToggleSwitch.vue?vue&type=template&id=69fc1a12&scoped=true"
import script from "./FormToggleSwitch.vue?vue&type=script&lang=js"
export * from "./FormToggleSwitch.vue?vue&type=script&lang=js"

import "./FormToggleSwitch.vue?vue&type=style&index=0&id=69fc1a12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fc1a12"]])

export default __exports__